import React from 'react';
import { useTranslation } from 'react-i18next';
import { Form, Input, Modal } from 'antd';
import debounce from 'lodash.debounce';
import { ALL_TAB_KEY, useTransportPerformanceGroupsStore } from 'shared/stores/use-transport-performance-groups';
import type { ICreateGroupFormFields, ICreateGroupModalProps } from './types';

export const CreateGroupModal: React.FC<ICreateGroupModalProps> = (props) => {
  const { isOpen, onClose } = props;
  const { t } = useTranslation('transport-mileage');

  const { groups, selectedIds, addGroup, setActiveTab } = useTransportPerformanceGroupsStore();

  const [form] = Form.useForm<ICreateGroupFormFields>();
  const handleOk = debounce(() => form.submit(), 200);

  const onFinishForm = (values: ICreateGroupFormFields) => {
    const name = values.name.trim();

    if (name.toLowerCase() === ALL_TAB_KEY || groups[name]) {
      form.setFields([{ name: 'name', errors: [t('group_name_exists')] }]);
      return;
    }

    addGroup(name, selectedIds);
    setActiveTab(name);
    onClose();
    form.resetFields();
  };

  const handleClose = () => {
    form.resetFields();
    onClose();
  };

  return (
    <Modal title={t('create_group')} open={isOpen} onCancel={handleClose} onOk={handleOk}>
      <Form form={form} name='create_transport_group' layout='vertical' onFinish={onFinishForm}>
        <Form.Item label={t('group_name')} name='name' rules={[{ required: true, message: t('group_name_required') }]}>
          <Input placeholder={t('group_name_placeholder')} maxLength={50} />
        </Form.Item>
      </Form>
    </Modal>
  );
};
